import { Box, IconButton, Typography } from '@mui/material';
import React, {
  useCallback, useContext, useEffect, useRef, useState,
} from 'react';
import { toast } from 'react-toastify';
import { defaultMessage } from 'Shared/Referencial/ReferencialService';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import UserContext from 'Shared/UserContext';
import { format } from 'date-fns';
import { getChallenges, getObjectives } from '../HomeServices';
// import Challenge from '../Challenge';
import Objective from '../Objective';

const activeStyle = {
  color: 'white',
  background:
    'transparent linear-gradient(213deg, #007BC6 0%, #1793DD 100%) 0% 0% no-repeat padding-box',
  boxShadow: '0px 4px 10px #108CD650',
  borderRadius: 12,
};
const inactiveStyle = {
  background: '#D7DFE4 0% 0% no-repeat padding-box',
  borderRadius: 12,
  color: '#286183',
};
const ObjectiveAndChallenges = () => {
  const {
    state: { user },
  } = useContext(UserContext);
  // const [objectives, setObjectives] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [cardPerSlide, setCardPerSlide] = useState(0);
  const [totalChallenges, setTotalChallenges] = useState(0);
  const [indexCard, setIndexCard] = useState(0);
  const contentWidth = useRef(null);
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setCardPerSlide(
        parseInt((contentWidth?.current?.getBoundingClientRect()?.width - 50) / 345, 10),
      );
    });
    resizeObserver.observe(contentWidth?.current);
    return () => resizeObserver.disconnect();
  }, [setCardPerSlide]);

  const nextElem = () => {
    setIndexCard(indexCard + 1);
  };
  const prevElem = () => {
    setIndexCard(indexCard - 1);
  };
  const getObjectivesList = useCallback(async () => {
    try {
      const objectivesList = await getObjectives(user.sellerId);
      // setObjectives(objectivesList);
      setTotalChallenges(objectivesList.reduce((total, obj) => (total + obj.ca), 0));
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    }
  }, []);

  const getChallengesList = useCallback(async () => {
    try {
      const objectivesList = await getChallenges();
      setChallenges(objectivesList.map((ch) => ({
        ...ch, startDate: format(new Date(ch.startDate), 'dd/MM/yyyy'), endDate: format(new Date(ch.endDate), 'dd/MM/yyyy'),
      })));
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    }
  }, []);

  useEffect(() => {
    getObjectivesList();
  }, [getObjectivesList]);
  useEffect(() => {
    getChallengesList();
  }, [getChallengesList]);
  console.log(challenges);
  return (
    <>
      <Box style={{ display: 'flex' }}>
        <Typography style={{ flexGrow: 1, color: '#000', font: 'normal normal 600 26px Montserrat' }}>
          Challenges et objectifs
        </Typography>
        <Box>
          <IconButton
            color="primary"
            style={{ ...(indexCard === 0 ? inactiveStyle : activeStyle), marginRight: 16 }}
            component="span"
            size="small"
            disabled={indexCard === 0}
            onClick={prevElem}
          >
            <KeyboardArrowLeftIcon />
          </IconButton>
          <IconButton
            color="primary"
            style={cardPerSlide + indexCard + 1 > challenges.length ? inactiveStyle : activeStyle}
            component="span"
            size="small"
            disabled={cardPerSlide + indexCard + 1 > challenges.length}
            onClick={nextElem}
          >
            <KeyboardArrowRightIcon />
          </IconButton>
        </Box>
      </Box>
      <Typography sx={{ font: 'normal normal medium 16px Montserrat' }}>
        CHALLENGES ET OBJECTIFS:
        {' '}
        <span style={{ font: 'normal normal bold 16px Montserrat', color: '#007BC6' }}>
          {totalChallenges.toFixed(2)?.replace(/\d(?=(\d{3})+\.)/g, '$& ')}
        </span>
      </Typography>
      <Box style={{ width: '100%', display: 'flex' }} ref={contentWidth}>
        {challenges.slice(indexCard, cardPerSlide + indexCard).map((ch) => (
          <Objective objective={ch} />
        ))}
      </Box>
    </>
  );
};

export default ObjectiveAndChallenges;
